import { todayPT } from "@homebound/activesupport";
import { PageBannerProps, useModal, usePageBanner } from "@homebound/beam";
import { useMemo } from "react";
import { ItemTemplateStatus, Order, ScopeChangeType } from "src/generated/graphqlTypes";
import { useRecentlyActivatedItemTemplatesQuery } from "src/routes/developments/procurement/components/GenerateNewBidRequestNotice.generated";
import { PlanBasedBidRequest } from "../DevelopmentProcurementPage";
import { DevelopmentTemplateItemsModalSize } from "./DevelopmentTemplateItemsModal";

type GenerateNewBidRequestNoticeProps = { developmentId: string };

/** Pins a page banner for 7 days after a new major version of an ItemTemplate is published. */
export function GenerateNewBidRequestNotice(props: GenerateNewBidRequestNoticeProps) {
  const { developmentId } = props;
  const { openModal } = useModal();
  const { data } = useRecentlyActivatedItemTemplatesQuery({
    variables: {
      filter: {
        development: [developmentId],
        status: [ItemTemplateStatus.Active],
        scopeChangeType: [ScopeChangeType.Major],
      },
      order: { activatedAt: Order.Desc },
      limit: 1,
    },
  });
  // The query is limited to the most recently activated item template
  const activatedAt = data?.itemTemplates[0]?.activatedAt;
  const showBanner =
    !!activatedAt && activatedAt.toPlainDate().until(todayPT(), { largestUnit: "day" }).days <= limitDaysToShowBanner;

  const banner: PageBannerProps | undefined = useMemo(
    () =>
      showBanner
        ? {
            type: "info",
            title: "New scope template versions have been created",
            primaryAction: {
              label: "Create New Bid Request",
              onClick: () =>
                openModal({
                  content: <PlanBasedBidRequest developmentId={developmentId} />,
                  size: DevelopmentTemplateItemsModalSize,
                }),
            },
          }
        : undefined,
    [showBanner, openModal, developmentId],
  );
  usePageBanner(banner);

  return null;
}

const limitDaysToShowBanner = 7;
